import { e as __rest, c as __assign } from '../../../../tslib.es6-80f01feb.js';
import React__default from 'react';

var ListBody = function (_a) {
    var children = _a.children, _b = _a.childrenForFishingEmpty, childrenForFishingEmpty = _b === void 0 ? null : _b, onScroll = _a.onScroll, rest = __rest(_a, ["children", "childrenForFishingEmpty", "onScroll"]);
    return (React__default.createElement("div", { className: 'bottom-of-lists-wrapper' },
        React__default.createElement("div", __assign({ className: 'scrollable-container', onScroll: onScroll }, rest),
            childrenForFishingEmpty,
            React__default.createElement("div", { className: "list-item-rows-container ".concat(childrenForFishingEmpty ? 'for-fishing' : '') }, children))));
};
var ListBodyFishingEmpty = function (_a) {
    var children = _a.children;
    return React__default.createElement("div", { className: 'fishing-result-empty-content' }, children);
};

export { ListBody, ListBodyFishingEmpty };
